var pug = require("!../../../../node_modules/pug-runtime/index.js");

function template(locals) {var pug_html = "", pug_mixins = {}, pug_interp;pug_mixins["container"] = pug_interp = function(className){
var block = (this && this.block), attributes = (this && this.attributes) || {};
pug_html = pug_html + "\u003Cdiv" + (pug.attrs(pug.merge([{"class": pug.classes(["container",className], [false,true])},attributes]), true)) + "\u003E";
block && block();
pug_html = pug_html + "\u003C\u002Fdiv\u003E";
};
pug_mixins["sliderButtons"] = pug_interp = function(className, isCount, isSmall, isHide){
var block = (this && this.block), attributes = (this && this.attributes) || {};
pug_html = pug_html + "\u003Cdiv" + (pug.attr("class", pug.classes(["sliderButtons",className], [false,true]), false, true)) + "\u003E";
if (isCount) {
pug_html = pug_html + "\u003Cdiv class=\"sliderButtons__counter\"\u003E\u003Cspan data-name=\"activeSlide\"\u003E1\u003C\u002Fspan\u003E\u002F\u003Cspan data-name=\"slidesLength\"\u003E15\u003C\u002Fspan\u003E\u003C\u002Fdiv\u003E";
}
if (!isHide) {
pug_html = pug_html + "\u003Cbutton class=\"sliderButtons__btn sliderButtons__btn--prev\"\u003E";
if (isSmall) {
pug_html = pug_html + "\u003Csvg width=\"8\" height=\"13\" viewBox=\"0 0 8 13\" fill=\"none\" xmlns=\"http:\u002F\u002Fwww.w3.org\u002F2000\u002Fsvg\"\u003E\n\u003Cpath d=\"M2.03027 12.2328C1.90119 12.3779 1.64303 12.3779 1.51395 12.3779C1.25579 12.3779 0.997632 12.3779 0.868553 12.2328C0.481314 11.7977 0.481314 11.2175 0.868553 10.9274L5.12818 6.57599L0.868554 2.22458C0.481315 1.93449 0.481315 1.3543 0.868554 0.919162C1.25579 0.484021 1.77211 0.629068 2.03027 0.919162L6.80621 5.85076C7.19345 6.14085 7.19345 6.72104 6.80621 7.15618L2.03027 12.2328Z\"\u002F\u003E\n\u003C\u002Fsvg\u003E\n";
}
else {
pug_html = pug_html + "\u003Csvg xmlns=\"http:\u002F\u002Fwww.w3.org\u002F2000\u002Fsvg\" xmlns:xlink=\"http:\u002F\u002Fwww.w3.org\u002F1999\u002Fxlink\" x=\"0px\" y=\"0px\"\n\t width=\"26px\" height=\"18px\" viewBox=\"0 0 26 18\"\u003E\n\t\u003Cpath stroke=\"none\" d=\"M17.4,0L16,1.5L23.2,9L16,16.5l1.4,1.5L26,9L17.4,0z\"\u002F\u003E\n\t\u003Cpath d=\"M23.5,8.5h-23v1h23V8.5z\"\u002F\u003E\n\u003C\u002Fsvg\u003E\n";
}
pug_html = pug_html + "\u003C\u002Fbutton\u003E\u003Cbutton class=\"sliderButtons__btn sliderButtons__btn--next\"\u003E";
if (isSmall) {
pug_html = pug_html + "\u003Csvg width=\"8\" height=\"13\" viewBox=\"0 0 8 13\" fill=\"none\" xmlns=\"http:\u002F\u002Fwww.w3.org\u002F2000\u002Fsvg\"\u003E\n\u003Cpath d=\"M2.03027 12.2328C1.90119 12.3779 1.64303 12.3779 1.51395 12.3779C1.25579 12.3779 0.997632 12.3779 0.868553 12.2328C0.481314 11.7977 0.481314 11.2175 0.868553 10.9274L5.12818 6.57599L0.868554 2.22458C0.481315 1.93449 0.481315 1.3543 0.868554 0.919162C1.25579 0.484021 1.77211 0.629068 2.03027 0.919162L6.80621 5.85076C7.19345 6.14085 7.19345 6.72104 6.80621 7.15618L2.03027 12.2328Z\"\u002F\u003E\n\u003C\u002Fsvg\u003E\n";
}
else {
pug_html = pug_html + "\u003Csvg xmlns=\"http:\u002F\u002Fwww.w3.org\u002F2000\u002Fsvg\" xmlns:xlink=\"http:\u002F\u002Fwww.w3.org\u002F1999\u002Fxlink\" x=\"0px\" y=\"0px\"\n\t width=\"26px\" height=\"18px\" viewBox=\"0 0 26 18\"\u003E\n\t\u003Cpath stroke=\"none\" d=\"M17.4,0L16,1.5L23.2,9L16,16.5l1.4,1.5L26,9L17.4,0z\"\u002F\u003E\n\t\u003Cpath d=\"M23.5,8.5h-23v1h23V8.5z\"\u002F\u003E\n\u003C\u002Fsvg\u003E\n";
}
pug_html = pug_html + "\u003C\u002Fbutton\u003E";
}
pug_html = pug_html + "\u003C\u002Fdiv\u003E";
};
pug_mixins["link"] = pug_interp = function(text, href, className, attributes){
var block = (this && this.block), attributes = (this && this.attributes) || {};
pug_html = pug_html + "\u003Ca" + (pug.attrs(pug.merge([{"class": pug.classes(["link",className], [false,true]),"href": pug.escape(href)},attributes]), true)) + "\u003E" + (pug.escape(null == (pug_interp = text) ? "" : pug_interp)) + "\u003C\u002Fa\u003E";
};
pug_mixins["input"] = pug_interp = function(type, id, name, className, error, inputClass, vueClass){
var block = (this && this.block), attributes = (this && this.attributes) || {};
pug_html = pug_html + "\u003Cdiv" + (pug.attr("class", pug.classes(["input",className], [false,true]), false, true)+pug.attr(":class", (vueClass || false), true, true)) + "\u003E";
block && block();
pug_html = pug_html + "\u003Cdiv class=\"input__field\"\u003E\u003Cinput" + (pug.attrs(pug.merge([{"class": pug.classes([inputClass], [true]),"type": pug.escape(type),"id": pug.escape(id),"name": pug.escape(name),"autocomplete": "off"},attributes]), true)) + "\u003E\u003C\u002Fdiv\u003E";
if ((error)) {
pug_html = pug_html + "\u003Cdiv class=\"input__error-text\"\u003E" + (null == (pug_interp = error) ? "" : pug_interp) + "\u003C\u002Fdiv\u003E";
}
pug_html = pug_html + "\u003C\u002Fdiv\u003E";
};



































































pug_html = pug_html + "\u003Cdiv class=\"popup-fullscreen\" @click.self=\"closePopup\"\u003E";
pug_mixins["container"].call({
block: function(){
pug_html = pug_html + "\u003Cbutton class=\"popup-fullscreen__close\" @click=\"closePopup\"\u003E\u003Csvg width=\"28\" height=\"28\" viewBox=\"0 0 28 28\" fill=\"none\" xmlns=\"http:\u002F\u002Fwww.w3.org\u002F2000\u002Fsvg\"\u003E\n\u003Cpath d=\"M2 2L26 26\" stroke-width=\"3\"\u002F\u003E\n\u003Cpath d=\"M26 2L2 26\" stroke-width=\"3\"\u002F\u003E\n\u003C\u002Fsvg\u003E\n\u003C\u002Fbutton\u003E\u003Cdiv class=\"popup-fullscreen__slider swiper-container\" ref=\"fullSlider\"\u003E\u003Cdiv class=\"swiper-wrapper\"\u003E\u003Cdiv class=\"swiper-slide popup-fullscreen__slide\" v-for=\"(card, i) in mediaArray\" :key=\"card.id\"\u003E\u003Cimg class=\"card-popup__main-slide-img swiper-lazy\" :src=\"card.img ? card.img : card\" alt=\"\"\u003E\u003Cdiv class=\"popup-fullscreen__main-slide-text\" v-if=\"card.text\"\u003E\u003Cdiv class=\"popup-fullscreen__main-slide-title\"\u003E${ card.text.title }}\u003C\u002Fdiv\u003E\u003Cdiv class=\"popup-fullscreen__main-slide-description\"\u003E${ card.text.description }}\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E";
pug_mixins["sliderButtons"]('popup-fullscreen__slider-btns sliderButtons--transparent', true, false, true);
pug_html = pug_html + "\u003C\u002Fdiv\u003E\u003Cdiv class=\"popup-fullscreen__btns-nav\"\u003E\u003Cdiv class=\"popup-fullscreen__btn popup-fullscreen__btn--prev\"\u003E\u003Csvg viewBox=\"0 0 10 18\" fill=\"#1A1A1A\" xmlns=\"http:\u002F\u002Fwww.w3.org\u002F2000\u002Fsvg\"\u003E\u003Cpath fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M1.39726 0L0 1.46179L7.20548 9L0 16.5382L1.39726 18L10 9L1.39726 0Z\"\u002F\u003E\u003C\u002Fsvg\u003E\n${ fullscreenbuttontext[0] || 'Предыдущее' }}\u003C\u002Fdiv\u003E\u003Cdiv class=\"popup-fullscreen__btn popup-fullscreen__btn--next\"\u003E${ fullscreenbuttontext[1] || 'Следующее' }}\u003Csvg viewBox=\"0 0 10 18\" fill=\"#1A1A1A\" xmlns=\"http:\u002F\u002Fwww.w3.org\u002F2000\u002Fsvg\"\u003E\u003Cpath fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M1.39726 0L0 1.46179L7.20548 9L0 16.5382L1.39726 18L10 9L1.39726 0Z\"\u002F\u003E\u003C\u002Fsvg\u003E\n\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E";
}
}, 'popup-fullscreen__container');
pug_html = pug_html + "\u003C\u002Fdiv\u003E";;return pug_html;};
module.exports = template;


//////////////////
// WEBPACK FOOTER
// ./blocks/popup/fullscreen/popup-fullscreen.pug
// module id = ./blocks/popup/fullscreen/popup-fullscreen.pug
// module chunks = 0